export enum EScheduledAction {
  ON = "ON",
  OFF = "OFF",
}
